import * as I18n from 'i18n-js';
import * as React from 'react';

import CoreLink from '@reverbdotcom/commons/dist/components/core_link';

import * as JoinLeft from '../../../../images/homepage/join-l.svg';
import * as JoinRight from '../../../../images/homepage/join-r.svg';

export default class SellInstrumenttCallout extends React.PureComponent<{}, null> {
  render() {
    return (
      <div className="sell-instrument-callout">
        <div className="sell-instrument-callout__img">
          <img
            src={JoinLeft}
            alt={I18n.t('discovery.homepage.sellInstrumentCallout.alt')}
          />
        </div>
        <div className="sell-instrument-callout__text">
          <h2>
            {I18n.t('discovery.homepage.loggedOutNew.listYourGear')}
          </h2>
          <p>
            {I18n.t('discovery.homepage.sellInstrumentCallout.body')}
          </p>
          <CoreLink
            to="/sell"
            trackName="HomepageSellOnReverb"
            className="button button--orange size-120 mobile-size-110"
          >
            {I18n.t('discovery.homepage.sellInstrumentCallout.action')}
          </CoreLink>
        </div>
        <div className="sell-instrument-callout__img">
          <img
            src={JoinRight}
            alt={I18n.t('discovery.homepage.sellInstrumentCallout.alt')}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/homepage/sell_instrument_callout.tsx